var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstpage",on:{"click":function($event){return _vm.close()}}},[_c('Header'),_c('img',{attrs:{"src":_vm.bgSpring,"alt":"","srcset":""}}),_c('Footer'),_c('ShareBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }